/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Queues_Contact_Code_Tree_NameInputs */

const en_tables_queues_contact_code_tree_name = /** @type {(inputs: Tables_Queues_Contact_Code_Tree_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const de_tables_queues_contact_code_tree_name = /** @type {(inputs: Tables_Queues_Contact_Code_Tree_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

/**
* | output |
* | --- |
* | "Name" |
*
* @param {Tables_Queues_Contact_Code_Tree_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_queues_contact_code_tree_name = /** @type {((inputs?: Tables_Queues_Contact_Code_Tree_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Queues_Contact_Code_Tree_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_queues_contact_code_tree_name(inputs)
	return de_tables_queues_contact_code_tree_name(inputs)
});